import { Button, X } from "@repo/ui";

type Props = {
  text: string;
  onClose: () => void;
};

export const PanelTitle = ({ text, onClose }: Props) => {
  return (
    <div className="mb-4 flex items-center justify-between">
      <h3 className="text-sm font-semibold text-gray-700">{text}</h3>
      <Button
        data-allow-navigation
        variant="ghost"
        size="icon_xs"
        icon={<X className="h-4 w-4" />}
        onClick={onClose}
      />
    </div>
  );
};
